import { render, staticRenderFns } from "./ReferralATDiscussionSchool.vue?vue&type=template&id=0aebcee3&scoped=true"
import script from "./ReferralATDiscussionSchool.vue?vue&type=script&lang=js"
export * from "./ReferralATDiscussionSchool.vue?vue&type=script&lang=js"
import style0 from "./ReferralATDiscussionSchool.vue?vue&type=style&index=0&id=0aebcee3&prod&scoped=true&lang=css"
import style1 from "@/assets/css/component/panel-simple.css?vue&type=style&index=1&id=0aebcee3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebcee3",
  null
  
)

export default component.exports